import { Link } from 'react-router-dom';
import MovieCard from '@/components/base/MovieCard';
import { movies } from '@/mocks/movies';

const list = [...movies].sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));

export default function LatestWorks() {
  return (
    <section className="w-full bg-background-100 px-4 md:px-8 py-12 md:py-16">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">最新影视作品</h2>
          <p className="mt-2 text-sm text-foreground-600">按更新时间排序，第一时间了解最新上线的影视资料。</p>
        </div>
        <Link
          to="/category"
          className="inline-flex items-center gap-1 self-start rounded-md border border-background-300/70 bg-background-50 px-4 py-2 font-label text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 whitespace-nowrap"
        >
          查看全部作品 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-5 lg:grid-cols-3">
        {list.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}